import type { QuestionModule } from "../contracts";
import {
  gridQuestionGroupCore,
  type GridQuestionGroupDefinition,
  type GridQuestionGroupDraft,
  type GridQuestionGroupEvent,
  type GridQuestionGroupRaw,
  type GridQuestionGroupResponse,
} from "./core";

const GridQuestionGroupView = () => null;

export const gridQuestionGroupModule: QuestionModule<
  GridQuestionGroupRaw,
  GridQuestionGroupDefinition,
  GridQuestionGroupDraft,
  GridQuestionGroupEvent,
  GridQuestionGroupResponse
> = {
  type: "grid_question_group",
  galleryFeatures: ["visual-groups", "baseline"],
  core: gridQuestionGroupCore,
  prompt: (definition) => ({ content: definition.heading }),
  views: {
    default: {
      id: "default",
      label: "Grid group",
      component: GridQuestionGroupView,
      arrangements: ["compact", "wide"],
      requiredControls: [],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.submit,
      action: { type: "submit" },
    },
  }),
};
